import * as echarts from "echarts";

export function get_alarm_detail_heart_chart_option(series_data, color, scatter_data) {
	let areaColor = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
		{
			offset: 0,
			color: 'rgba(121, 238, 224, 0.2)'
		},
		{
			offset: 1,
			color: 'rgba(121, 238, 224, 0)'
		}
	]);
	if (color != 'rgba(121, 238, 224, 1)') {
		areaColor = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
			{
				offset: 0,
				color: 'rgba(255, 114, 142, 0.2)'
			},
			{
				offset: 1,
				color: 'rgba(255, 114, 142, 0)'
			}
		]);
	}
	let option = {
		grid: {
			x: 0,
			y: 30,
			x2: 0,
			y2: 0,
			containLabel: true,
		},
		xAxis: {
			type: 'category',
			boundaryGap: false,
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: false,
				color: "rgba(160, 208, 231, 1)", //坐标的字体颜色
				fontSize: 10
			},
			axisTick: {
				show: false
			},
			splitLine: {
				show: false,
				lineStyle: {
					color: "rgba(198, 231, 255, 0.2)",
					width: 0.5
				},
			},
			axisLine: {
				lineStyle: {
					width: 0,
					color: 'rgba(198, 231, 255, 1)'
				}
			}
		},
		yAxis: {
			type: 'value',
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: false,
				color: "rgba(160, 208, 231, 1)", //坐标的字体颜色
				fontSize: 10
			},
			splitLine: {
				show: false,
				lineStyle: {
					color: "rgba(198, 231, 255, 0.2)",
					width: 0.5
				},
			},
			min: -10,
			max: 13
		},
		series: [
			{
				data: series_data,
				type: 'line',
				lineStyle: {
					color: color,
					width: 2
				},
				symbolSize: 0,
				// areaStyle: {
				// 	color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
				// 		{
				// 			offset: 0,
				// 			color: 'rgba(175, 224, 247, 0.3)'
				// 		},
				// 		{
				// 			offset: 1,
				// 			color: 'rgba(175, 225, 249, 0)'
				// 		}
				// 	])
				// },
				label: {
					show: false,
					position: 'top',
					color: 'rgba(219, 238, 250, 1)'
				},
				animation: false,
				// areaStyle: {
				// 	origin: 'start',
				// 	color: areaColor
				// },
			},
			{
				animation: false,
				symbolSize: [10, 10],
				data: [
					scatter_data
				],
				type: 'scatter',
				itemStyle: {
					normal: {
						color: color,
						borderColor: "#ffffff00",
						borderWidth: 3,
					}
				},
			}
		]
	}
	return option;
}